module.exports = __webpack_public_path__ + "static/media/add-white.d4abaa8e.svg";